<div class="three-wrapper">
  <iframe class="iframe-3q" [src]="url | safe" frameborder="0" scrolling="no" allowfullscreen></iframe>
</div>

<!--  <div id="sdnPlayer_mNRbWvgcnBQLpJh" style="width:640px;height:360px;"></div> -->
